<template>
	<div class="dashboard-content">
		<div v-if="isLoading" class="loading-data">
			<b-spinner variant="light" label="Get Data" class="mr-2"></b-spinner> loading...
		</div>
		<div id="row1" class="row row1 m-0">
			<ColumnViewer idName="column3" className="column3 col-4 p-0">
				<div id="card6">
					<CardViewer className="card6 d-flex justify-content-between align-items-center">
						<TextViewer idName="text9" value="STOCK LEVEL" className="text9" />
						<TextViewer idName="text10" :value="currentTime" className="text9" />
					</CardViewer>
				</div>
			</ColumnViewer>
			<ColumnViewer idName="column4" className="column4 col-8 p-0">
				<div id="card5">
					<CardViewer className="card5 d-flex justify-content-center align-items-center">
						<TextViewer idName="text7" value="DELIVERY ACHIEVEMENT ACCUMULATION" className="text7" />
					</CardViewer>
				</div>
			</ColumnViewer>
		</div>
		<div id="row10" class="row row10 m-0 bg-white">
			<ColumnViewer idName="column17" className="column17 col-4 p-0 d-flex flex-column">
				<div id="card18">
					<BarChartViewer idName="barchart40" :chartOptions="barchart40Options" className="barchart40"
					:dataChart="this.dataDashboard.dataChart"
					chartLabel="customer_code"
					chartValue="percentage_actual_out_vs_plan_out"
					:height="153"
					/>
				</div>
			</ColumnViewer>
			<ColumnViewer idName="column22" className="column22 col-8  p-0">
				<div id="row11" class="row row10 m-0">
					<ColumnViewer idName="column24" className="column24 col-12  p-0">
						<CustomerList :items="this.dataDashboard.customerList" />
					</ColumnViewer>
				</div>
				<div id="row11" class="row row10 m-0">
					<ColumnViewer idName="column25" className="column25 col-3  p-0 d-flex">
						<div id="card24" class="total-card">
							<CardViewer className="card24 p-0">
								<div id="card25">
									<CardViewer className="card25">
										<TextViewer idName="text27" value="DELAY ITEMS" className="text27" />
									</CardViewer>
								</div>
								<div id="card-danger">
									<CardViewer className="card-danger">
										<TextViewer idName="text28"  :value="formatNumber(this.dataDashboard.delayItems)" className="text28" />
									</CardViewer>
								</div>
							</CardViewer>
						</div>
					</ColumnViewer>
					<ColumnViewer idName="column25" className="column25 col-3  p-0">
						<div id="card24" class="total-card">
							<CardViewer className="card24 p-0">
								<div id="card25">
									<CardViewer className="card25">
										<TextViewer idName="text27" value="TTL PLAN (PCS)" className="text27" />
									</CardViewer>
								</div>
								<div id="card-ttl">
									<CardViewer className="card-ttl">
										<TextViewer idName="text-dark" :value="formatNumber(this.dataDashboard.ttlPlan)" className="text-dark" />
									</CardViewer>
								</div>
							</CardViewer>
						</div>
					</ColumnViewer>
					<ColumnViewer idName="column25" className="column25 col-3 p-0">
						<div id="card24" class="total-card">
							<CardViewer className="card24 p-0">
								<div id="card25">
									<CardViewer className="card25">
										<TextViewer idName="text27" value="TTL DELIVER (PCS)" className="text27" />
									</CardViewer>
								</div>
								<div id="card26">
									<CardViewer className="card26">
										<TextViewer idName="text28" :value="formatNumber(this.dataDashboard.ttlDelivery)" className="text28 text-danger" />
									</CardViewer>
								</div>
							</CardViewer>
						</div>
					</ColumnViewer>
					<ColumnViewer idName="column25" className="column25 col-3  p-0">
						<div id="card24" class="total-card">
							<CardViewer className="card24 p-0">
								<div id="card25">
									<CardViewer className="card25">
										<TextViewer idName="text27" value="PERCENTAGE" className="text27" />
									</CardViewer>
								</div>
								<div id="card-ttl">
									<CardViewer className="card-ttl">
										<TextViewer idName="text-dark"  :value="(this.dataDashboard.ttlPercentage != undefined ? this.dataDashboard.ttlPercentage : 0) + '%'" className="text-dark" />
									</CardViewer>
								</div>
							</CardViewer>
						</div>
					</ColumnViewer>
				</div>
			</ColumnViewer>
		</div>
		<div id="row11" class="row row11 ">
			<ColumnViewer idName="column13" className="column13 col-12">
				<div id="card14">
					<CardViewer className="card14">
						<div class="d-flex justify-content-between">
							<TextViewer idName="text15" :value="`DELIVERY ACHIEVEMENT ${currentCustomerCode}`" className="text15" />
							<div v-if="isTableLoading" class="loading-table-data mr-1">
								<b-spinner variant="light" label="Get Data" class="mr-1" small></b-spinner> loading...
							</div>
						</div>
						<TableViewer 
							idName="table16" className="table16" 
							:data="this.tableList" 
							:fields="tableFields"
							:sticky-header="true"
							ref="scrollContainer"
							>
							<template v-slot:cell(no)="row">
								{{ row.index + 1 }}
							</template>
							<template v-slot:cell(part_name)="row">
								<app-long-text :maxLength="18" :mdMaxLength="18" :text="row.item.part_name != '' && row.item.part_name != null ? row.item.part_name : ''" />
							</template>
							<template v-slot:cell(standart_per_day)="row">
								<div class="text-td-warning">{{ row.item.standart_per_day | thousandSeparator }}</div>
							</template>
							<template v-slot:cell(stock_awal)="row">
								<div class="text-td-success">{{ row.item.stock_awal | thousandSeparator }}</div>
							</template>
							<template v-slot:cell(actual_in)="row">
								<div class="text-td-warning">{{ row.item.actual_in | thousandSeparator }}</div>
							</template>
							<template v-slot:cell(plan_out)="row">
								<div class="text-td-warning">{{ row.item.plan_out | thousandSeparator }}</div>
							</template>
							<template v-slot:cell(actual_out)="row">
								<div class="text-td-warning">{{ row.item.actual_out | thousandSeparator }}</div>
							</template>
							<template v-slot:cell(sisa_stock)="row">
								<div class="text-td-warning">{{ row.item.sisa_stock | thousandSeparator }}</div>
							</template>
							<template v-slot:cell(delay)="row">
								<div class="text-td-full-danger">{{ row.item.delay | thousandSeparator }}</div>
							</template>
							<template v-slot:cell(gap)="row">
								<div class="text-td-warning">{{ row.item.gap | thousandSeparator }}</div>
							</template>
							<template v-slot:cell(remarks)="row">
								<RemarksIndicator :gap="row.item.gap" :partId="row.item.part_id" />
							</template>
						</TableViewer>
					</CardViewer>
				</div>
			</ColumnViewer>
		</div>
	</div>
</template>
<style lang="scss" scoped>
@import '../../assets/scss/dashboard-page.scss';
@import '../../assets/dashboardcss/andondelivery.scss';

::v-deep .table thead th {
    min-width: fit-content !important;
	padding: 0.75rem !important;
}

.loading-table-data {
    z-index: 1;
    background: #CCC;
    display: flex;
    padding: 4px;
    align-items: center;
    border-radius: 5px;
    opacity: 0.9;
}
</style>
<script>
import RowViewer from '@/components/dashboard/RowViewer';
import ColumnViewer from '@/components/dashboard/ColumnViewer';
import CardViewer from '@/components/dashboard/CardViewer';
import TextViewer from '@/components/dashboard/TextViewer';
import ListViewer from '@/components/dashboard/ListViewer';
import TableViewer from '@/components/dashboard/TableViewer';
import BarChartViewer from '@/components/dashboard/BarChartViewer';
import { thousandSeparator } from '@/utils/thousandSeparator';
import RemarksIndicator from './components/RemarksIndicator';
import CustomerList from './components/CustomerList';
import { nextTick } from 'vue';

export default {
	components: {
		RowViewer, ColumnViewer, CardViewer, TextViewer, ListViewer, TableViewer, BarChartViewer, 
		RemarksIndicator, CustomerList
	},
	data() {
		return {
			dataDashboard: [],
			currentTime: "",
			barchart40Options: {
				chart: {
                    background: "#274e13"
                },
				yaxis: {
                    labels: {
                        formatter: function (val) {
							return val.toFixed(2)
						},
						style: {
							colors: "#ffffff"
						}
                    }
                },
				xaxis: {
                    labels: {
						style: {
							colors: "#ffffff"
						}
                    }
                },
				yaxisLabel : false,
			},
			isLoading: false,
			isTableLoading: false,
			dataChart: [],
			customerList: [],
			tableFields : [
				{ "no": {}, "label": "#", key: 'no' },
				{ "partNo": {}, "class": "th-code", "label": "PART NO", key: 'part_number' },
				{ "partName": {}, "class": "th-name", "label": "PART NAME", key: 'part_name' },
				{ "std": {}, "class": "th-name th-currency", "label": "STD / DAY", key: 'standart_per_day'},
				{ "sto": {}, "class": "th-name th-currency", "label": "BEG. STOCK", key: 'stock_awal'},
				{ "plnOut": {}, "class": "th-name th-currency", "label": "PLN OUT", key: 'plan_out'},
				{ "ttlIn": {}, "class": "th-name th-currency", "label": "TTL IN", key: 'actual_in'},
				{ "ttlOut": {}, "class": "th-name th-currency", "label": "TTL OUT", key: 'actual_out'},
				{ "stock": {}, "class": "th-name th-currency", "label": "END STOCK", key: 'sisa_stock'},
				{ "delay": {}, "class": "th-delay th-currency p-0", "label": "DELAY", key: 'delay'},
				{ "customer": {}, "class": "th-name", "label": "CUSTOMER", key: 'customer'},
				{ "gap": {}, "class": "th-name th-currency", "label": "GAP", key: 'gap'},
				{ "remarks": {}, "class": "th-name", "label": "REMARKS", key: 'remarks'},
			],
			tableList: [],
			scrollAmount: 1,
      		scrollInterval: 50,
			customerIndex: 0,
			isFirstCustomer: false,
			currentCustomerCode: '',
			barchart400Interval : null,
			barchart400IntervalTime : null,
			barchart400Page : 1,
			barchart400MaxPage : 15,
			barchart400DataCount : 0,
		}
	},
	mounted() {
		this.getAndonDeliveryData();
		this.getAndonInterval();
		this.runDateTime();
	},
	methods: {
		startBarchart400Interval(){
			if(this.barchart400Interval != null){
				clearInterval(this.barchart400Interval)
			}
			// console.log('masuk', this.barchart400DataCount)
			let _this = this
			this.barchart400Interval = setInterval(function (){
				var maxPage = Math.floor(_this.barchart400DataCount / _this.barchart400MaxPage) + 1
				_this.barchart400Page = (_this.barchart400Page % maxPage) + 1;
				
				_this.$http.get(process.env.VUE_APP_API_URL + `DataSource/getandondeliverydata?page=${_this.barchart400Page}`).then(result => {
					if (result != null) {
						_this.dataDashboard.dataChart = result.data.dataChart;
					}
					
					return true;
				}).catch(function (error) {
					_this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
				});
			}, this.barchart400IntervalTime * 1000);
		},
		getAndonDeliveryData() {
			this.isLoading = true;
			var this_ = this;
			return this.$http.get(process.env.VUE_APP_API_URL + `DataSource/getandondeliverydata?page=${this.barchart400Page}`).then(result => {
				if (result != null) {
					this_.dataDashboard = result.data;
					this_.barchart400DataCount = this.dataDashboard.dataChartCount
					this_.barchart400MaxPage = this.dataDashboard.barchartMaxData
					this_.barchart400IntervalTime = this.dataDashboard.barchartInterval
					this_.customerList = result.data.customerList;
					if (this_.customerList.length > 0) {
						if (!this_.isFirstCustomer) {
							this_.getAndonDeliveryAchievementData(this_.customerList[0].CustomerName);
						}
					}
					if(this_.barchart400DataCount > this_.barchart400MaxPage && this_.dataDashboard.dataChart){
						this_.startBarchart400Interval()
					}
				}
				this_.isLoading = false;
				return true;
			}).catch(function (error) {
				this_.isLoading = false;
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		},
		getAndonDeliveryAchievementData(customerCode) {
			this.isTableLoading = true;
			this.currentCustomerCode = customerCode;
			var this_ = this;
			return this.$http.get(process.env.VUE_APP_API_URL + `DataSource/getandondeliveryachievement/${customerCode}`).then(result => {
				if (result != null) {
					this_.tableList = result.data.tableList;
					this_.customerIndex++;
					
					setTimeout(() => {
						this_.startAutoScroll();
					}, 2000);
				}
				this_.isTableLoading = false;
				return true;
			}).catch(function (error) {
				this_.isTableLoading = false;
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		},
		startAutoScroll() {
			var this_ = this;
			this.scrollIntervalId = setInterval(() => {
				if (this_.$refs.scrollContainer == null || this_.$refs.scrollContainer == undefined) {
					this_.stopAutoScroll();
					return;
				}
				if (this_.$refs.scrollContainer.$el == null || this_.$refs.scrollContainer.$el == undefined) {
					this_.stopAutoScroll();
					return;
				}
				if (this_.$refs.scrollContainer.$el.scrollTop == null || this_.$refs.scrollContainer.$el.scrollTop == undefined) {
					this_.stopAutoScroll();
					return;
				}
				this_.isFirstCustomer = true;
				this_.$refs.scrollContainer.$el.scrollTop += this_.scrollAmount;
				
				if (
					this_.$refs.scrollContainer.$el.scrollTop + 
					this_.$refs.scrollContainer.$el.clientHeight >= 
					this_.$refs.scrollContainer.$el.scrollHeight
				) {
					this_.stopAutoScroll();
					if (this_.customerIndex >= this_.customerList.length) {
						this_.customerIndex = 0;
					}
					if (this_.tableList.length <= 15 && this_.tableList.length > 0) {
						setTimeout(() => {
							this_.getAndonDeliveryAchievementData(this_.customerList[this_.customerIndex].CustomerName);
						}, 8000);
					} else {
						this_.getAndonDeliveryAchievementData(this_.customerList[this_.customerIndex].CustomerName);
					}
				}
			}, this.scrollInterval);
		},
		stopAutoScroll() {
			clearInterval(this.scrollIntervalId);
		},
		runDateTime() {
			setInterval(() => {
				const now = new Date();
				const day = String(now.getDate()).padStart(2, '0');
				const month = String(now.getMonth() + 1).padStart(2, '0');
				const year = now.getFullYear();
				const hours = String(now.getHours()).padStart(2, '0');
				const minutes = String(now.getMinutes()).padStart(2, '0');
				const seconds = String(now.getSeconds()).padStart(2, '0');
				this.currentTime = `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
			}, 1000);
		},
		roundNumber(value, decimals) {
			return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals).toFixed(decimals);
		},
		formatNumber(value) {
            return thousandSeparator(value);
        },
		getAndonInterval() {
			let this_ = this;
			return this.$http.get(process.env.VUE_APP_API_URL + `DataSource/getandonrefreshinterval`).then(result => {
				if (result != null) {
					if(result.data != null) {
						if (result.data.interval != null && result.data.interval != undefined
							&& result.data.interval > 0) {
							this_.runAutorefresh(result.data.interval);
						}
					}
				}
				return true;
			}).catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		},
		runAutorefresh(interval) {
			let this_ = this;
			setInterval(() => {
				this_.getAndonDeliveryData();
			}, (1000 * 60 * interval));
		},
	},
}
</script>